interface HeadingProps {
  text: string;
}

export function Heading({text}: HeadingProps): JSX.Element {
  return (
    <h1 className=" ml-12 lg:ml-0 text-3xl lg:text-4xl font-bold my-2 text-green-800 dark:text-green-600 mb-6">{text}</h1>
  )
}


